import type { FC } from 'react';
import {
  Box,
  Container,
  Link,
  Stack,
  Typography
} from '@mui/material';
import LogoFooter from './LogoFooter';
import { LINK_COOKIE_POLICY, LINK_PRIVACY } from "../constants";
import React from "react";
import i18n from "i18next";

const sections = [
  {
    title: 'Privacy Policy',
    href: '/privacy'
  },
  {
    title: 'Terms',
    href: '/tos'
  },
  /*{
    title: 'F.A.Q',
    href: '/faq'
  },*/
];

const Footer: FC = (props) => (
    <Box
        sx={{
          backgroundColor: '#edf0f4',
          py: 0.5,
          px: 2,
          minHeight: 42,
          display: 'flex',
          alignItems: 'center',
          borderTop: '1px solid rgba(0,0,0,0.08)',
        }}
        {...props}
    >
      <Container maxWidth="xl">
        <Stack
            direction={{ xs: 'column', md: 'row' }}
            alignItems="center"
            justifyContent="space-between"
            spacing={{ xs: 1, md: 2 }}
        >
          <Stack
              direction="row"
              alignItems="center"
              spacing={1}
          >
            <LogoFooter />

            <Typography
                color="textSecondary"
                variant="caption"
                sx={{
                  lineHeight: 1,
                  mt: '2px',
                  whiteSpace: 'nowrap',
                }}
            >
              {i18n.t("copyright_footer")}
            </Typography>
          </Stack>

          <Stack
              direction="row"
              spacing={2}
              alignItems="center"
              flexWrap="wrap"
              justifyContent="center"
          >
            {sections.map((section) => (
                <Link
                    key={section.title}
                    href={section.href}
                    color="textPrimary"
                    variant="caption"
                    underline="hover"
                    sx={{
                      whiteSpace: 'nowrap',
                    }}
                >
                  {section.title}
                </Link>
            ))}
          </Stack>
        </Stack>
      </Container>
    </Box>
);

export default Footer;
